import type { Availability } from '@ab-core/graphql/dist';
import type { FC } from 'react';
import React from 'react';
import { AggregatedMainChannelAvailability } from './aggregatedMainChannelAvailability';
import { CartChannelAvailability } from './cartChannelAvailability';
import { DeliveryTimeInfo } from './deliveryTimeInfo';
import { PickupChannels } from './pickupChannelsModal';
import { ZajadaczInfo } from './zajadaczInfo';

export type AvailabilitiesProps = Omit<Availability, 'sku'> & {
    quantityUnit?: string;
    showPickupChannels?: boolean;
    quantity: number;
    customDeliveryInfo?: string;
};

export const AvailabilitiesContainer: FC<AvailabilitiesProps> = (props) => {
    const {
        aggregatedMainChannelQuantity,
        procuredProduct,
        quantityUnit,
        deliveryFromFactory,
        zajadaczChannelAvailability,
        cartChannelAvailability,
        pickupChannelsAvailability,
        mainChannelAvailability,
        phillipsburgChannelAvailability,
        quantity,
        showPickupChannels = true,
        deliveryTimeInfoIdentifier,
        customDeliveryInfo
    } = props;

    return (
        <>
            {!customDeliveryInfo && (
                <>
                    <AggregatedMainChannelAvailability
                        quantityUnit={quantityUnit}
                        aggregatedMainChannelQuantity={aggregatedMainChannelQuantity}
                        deliveryFromFactory={deliveryFromFactory}
                        procuredProduct={procuredProduct}
                    />
                    {showPickupChannels && (
                        <>
                            <CartChannelAvailability
                                quantityUnit={quantityUnit}
                                cartChannelAvailability={cartChannelAvailability}
                                deliveryFromFactory={deliveryFromFactory}
                            />
                            <PickupChannels
                                quantityUnit={quantityUnit}
                                pickupChannelsAvailability={pickupChannelsAvailability}
                                isVisible={showPickupChannels}
                            />
                        </>
                    )}
                    <ZajadaczInfo
                        quantity={quantity}
                        identifier={deliveryTimeInfoIdentifier}
                        mainChannelAvailability={mainChannelAvailability}
                        zajadaczChannelAvailability={zajadaczChannelAvailability}
                    />
                </>
            )}
            <DeliveryTimeInfo
                mainChannelAvailability={mainChannelAvailability?.availability?.availableQuantity}
                phillipsburgChannelAvailability={phillipsburgChannelAvailability?.availability?.availableQuantity}
                quantity={quantity}
                identifier={deliveryTimeInfoIdentifier}
                customDeliveryInfo={customDeliveryInfo}
                procuredProduct={procuredProduct}
                deliveryFromFactory={deliveryFromFactory}
            />
        </>
    );
};
